module.exports = __webpack_public_path__ + "static/techbragins-aa646b71d12848ce30cc8c4fd4540664.svg";